import React,{useState} from 'react'
import AddedProducts from '../MinComponents/AddedProducts'
import AddProductForm from '../MinComponents/AddProductForm'
import { useEffect } from 'react';
import axios from "axios";
import Loading from '../MinComponents/Loading';
const ProductsTab = () => {
  const [products,setProducts]=useState([]);
  const [isLoading,setLoading]=useState(true);


  useEffect(()=>{
    var url=`${process.env.REACT_APP_BASE}/products`
    axios.get(url)
    .then(res=>{
      setProducts(res.data.products);
      setLoading(false);
    })
    .catch(err=>{
      console.log(err)
    });
  },[]);
  const addProducts=(item)=>{
    setProducts((products)=>{
      return [...products,item];
    })
  }
  const removeProduct=(id)=>{
    try{

      
      axios.delete(`${process.env.REACT_APP_BASE}/product/${id}`)
      .then((res)=>{
        setProducts(products.filter(product=>product._id!==id));  
        console.log(res);
      })     
    }catch(e){
      return;
    }

  }
  return (
    <div className="p-10 grid grid-cols-1 gap-5">
      <div className='flex justify-center'>
        <AddProductForm editProduct={addProducts}/>
      </div>
      {isLoading?
      <Loading/>
      :
        products.length ===0?
        <div>
          No Products added to your portfolio
        </div>
        :
        <div className="p-10 grid-rows-1 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {products.map((item)=>{
            return <AddedProducts removeProduct={removeProduct} key={item._id} data={item}/>
          })}
        </div>
      }
      
    </div>
  )
}

export default ProductsTab